export default "__VITE_ASSET__DKo8YrDk__"